import React from 'react';
import { LaCarte } from '../../models/laCarte';
import { element } from '../../models/element';
import LaCarteMenuElement from './LaCarteMenuElement';
import GeneralInfo from '../GeneralInfo/generalInfo';
import { various } from '../../models/various';

export interface LaCarteMenuProps {
    menu?: LaCarte
    onAllergensListClick: any
    various?: various

}

function LaCarteMenu(props: LaCarteMenuProps) {
    if (!!props.menu)
        return (
            <div>
                <div className='menu-title'>Menù alla carta</div>
                <div className='menu-content'>

                    {/* ANTIPASTI */}
                    <div className='menu-title-small'>Antipasti</div>
                    {
                        props.menu.appetizers.map((a: element) => <LaCarteMenuElement onAllegensListClick={props.onAllergensListClick} key={a.prodotto} element={a} />)
                    }
                    {/* PRIMI */}
                    <div className='menu-title-small'>Primi</div>
                    {
                        props.menu.first.map((a: element) => <LaCarteMenuElement onAllegensListClick={props.onAllergensListClick} key={a.prodotto} element={a} />)
                    }
                    {/* SECONDI */}
                    <div className='menu-title-small'>Secondi</div>
                    {
                        props.menu.second.map((a: element) => <LaCarteMenuElement onAllegensListClick={props.onAllergensListClick} key={a.prodotto} element={a} />)
                    }
                    {/* CONTORNI */}
                    <div className='menu-title-small'>Contorni</div>
                    {
                        props.menu.side.map((a: element) => <LaCarteMenuElement onAllegensListClick={props.onAllergensListClick} key={a.prodotto} element={a} />)
                    }
                    {/* DOLCI */}
                    <div className='menu-title-small'>Dolci</div>
                    {
                        props.menu.sweet.map((a: element) => <LaCarteMenuElement onAllegensListClick={props.onAllergensListClick} key={a.prodotto} element={a} />)
                    }
                    <GeneralInfo various={props.various} />
                </div>
            </div>
        );
    else
        return <></>
}

export default LaCarteMenu;